import React from 'react';
import { Result, Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PaymentFail = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Result
            status="error"
            title={t("Payment failed")}
            subTitle={t("We're sorry. An error occurred during payment processing. Please try again.")}
            extra={[
                <Button type="primary" key="console" onClick={() => navigate('/')}>
                    {t("Go to Dashboard")}
                </Button>,
                <Link to="/settings" key="retry">
                    <Button>{t("Try Again")}</Button>
                </Link>,
            ]}
        />
    );
};

export default PaymentFail;